import React from 'react';
import { ClassNameMap } from '@material-ui/styles';
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker
} from "@material-ui/pickers";
import { makeStyles } from '@material-ui/core/styles';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { ParsableDate } from '@material-ui/pickers/constants/prop-types';

interface BillingDateFieldProps {
    parentClasses: ClassNameMap,
    title: string,
    description: string,
    disabled: boolean,
    value: ParsableDate,
    setValue: any,
    className?: string,
}


const useStyles = makeStyles((theme) => ({
    dateTimePicker: {
        "& h3":
        {
            fontSize: '3rem'
        },
        "& h4":
        {
            fontSize: '2rem'
        },
        "& button":
        {
            minWidth: 0
        },
    }
}));

const BillingDateField: React.FC<BillingDateFieldProps> = ({
    parentClasses,
    title,
    description,
    disabled,
    value,
    setValue,
    className = "",
}) => {
    const classes = useStyles();

    const handleOnChange =  (date: MaterialUiPickersDate, value?: string| null | undefined): void=>{
        setValue(date);
    }

    return (
        <div>
            <div className={`${parentClasses.formControlLabel} ${className}`}>
                {title.toUpperCase()}
            </div>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                    InputProps={{ classes: { root: `${parentClasses.textFieldInput}` }}}
                    format="dd/MM/yyyy"
                    placeholder="dd/mm/yyyy"
                    inputVariant='outlined'
                    initialFocusedDate={null}
                    invalidDateMessage='Invalid Date'
                    value={value}
                    disabled={disabled}
                    onChange={handleOnChange}
                    DialogProps={{
                        className: classes.dateTimePicker
                    }}
                />
            </MuiPickersUtilsProvider>
            <div className={`${parentClasses.formControlLabelSub} ${className}`}>
                {description}
            </div>
        </div>
    );
}

export default BillingDateField;